export default "__VITE_ASSET__C3ttCF8a__"